import React, { ChangeEvent, useRef } from 'react';

import './AdvancedSmsCode.less';

interface CodeInputProps {
  value: string;
  length?: number;
  onChange: (val: string) => void;
}

const AdvancedSmsCode = ({ value, length = 6, onChange }: CodeInputProps) => {
  const inputsRef = useRef<(HTMLInputElement | null)[]>([]);

  const handleChange = (
    element: ChangeEvent<HTMLInputElement>,
    idx: number
  ) => {
    const inputValue = element.target.value;

    const char = inputValue.slice(-1);

    if (!/^[a-zA-Z0-9]$/.test(char)) {
      return;
    }

    const chars = value.split('');
    chars[idx] = char.toUpperCase();

    onChange(chars.join('').slice(0, length));

    if (idx < length - 1) {
      inputsRef.current[idx + 1]?.focus();
    }
  };

  const handleKeyDown = (
    element: React.KeyboardEvent<HTMLInputElement>,
    idx: number
  ) => {
    if (element.key === 'Backspace') {
      if (value[idx]) {
        const chars = value.split('');
        chars[idx] = '';
        onChange(chars.join(''));
      } else if (idx > 0) {
        inputsRef.current[idx - 1]?.focus();
      }
    }
  };

  return (
    <div className="code-input" data-sentry-mask>
      {Array.from({ length }).map((_, idx) => (
        <input
          key={idx}
          ref={(el) => (inputsRef.current[idx] = el)}
          maxLength={1}
          value={(value[idx] ?? '').toUpperCase()}
          onChange={(e) => handleChange(e, idx)}
          onKeyDown={(e) => handleKeyDown(e, idx)}
          autoCapitalize="characters"
          autoCorrect="off"
          spellCheck={false}
          inputMode="text"
        />
      ))}
    </div>
  );
};

export default AdvancedSmsCode;
